export default __webpack_public_path__ + "static/bg-home-5abc2380fe3adeef4f1048b11ada8e51.jpeg";